import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { MDSTypography } from '@marqvision/mds-v2';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'unset',
    gap: '6px',
  },
});

type Props = {
  label: string;
};

export const FormItem = (props: React.PropsWithChildren<Props>) => {
  const { label, children } = props;
  const classes = useStyles();
  
  return (
    <div className={classes.wrapper}>
      <MDSTypography variant="T14" weight="medium">
        {label}
      </MDSTypography>
      {children}
    </div>
  );
};